import { useState, useEffect } from "react"
import { Input, Button } from "antd"

const { TextArea } = Input;

export default function GoogleTest() {
  const [tokens, setTokens] = useState(null)
  const [isAuthenticated, setIsAuthenticated] = useState(false)
  const [loading, setLoading] = useState(false)
  const [events, setEvents] = useState([])
  const [authError, setAuthError] = useState(null)


  const [eventForm, setEventForm] = useState({
    title: "",
    description: "",
    startDateTime: "",
    endDateTime: "",
    timeZone: "America/New_York",
    attendees: [],
  })

  const updateTokens = (newTokens) => {
    setTokens(newTokens)
    localStorage.setItem("googleTokens", JSON.stringify(newTokens))
  }

  // Función para manejar errores de autenticación
  const handleAuthError = (error) => {
    setAuthError(error)
    setIsAuthenticated(false)
    setTokens(null)
    localStorage.removeItem("googleTokens")
  }

  useEffect(() => {
    // 1. PRIMER MOMENTO: Al cargar la página, verifica si YA HAY tokens guardados
    const savedTokens = localStorage.getItem("googleTokens")
    if (savedTokens) {
      try {
        const parsedTokens = JSON.parse(savedTokens)

        // Verificar que el refresh_token esté presente
        if (!parsedTokens.refresh_token) {
          console.error("❌ No refresh token found in saved tokens")
          localStorage.removeItem("googleTokens")
          setAuthError("Refresh token missing. Please re-authenticate.")
          return
        }

        setTokens(parsedTokens)
        setIsAuthenticated(true)
        fetchEvents(parsedTokens)
      } catch (error) {
        console.error("Error parsing saved tokens:", error)
        localStorage.removeItem("googleTokens")
      }
    }

    // 2. SEGUNDO MOMENTO: Cuando Google redirige de vuelta con los tokens
    const urlParams = new URLSearchParams(window.location.search)
    const accessToken = urlParams.get("access_token")
    const refreshToken = urlParams.get("refresh_token")
    const expiresIn = urlParams.get("expires_in")
    const error = urlParams.get("error")

    if (error) {
      let errorMessage = "Failed to authenticate with Google Calendar"

      switch (error) {
        case "no_refresh_token":
          errorMessage = "No refresh token received. Please try authenticating again."
          break
        case "auth_failed":
          errorMessage = "Authentication failed. Please try again."
          break
        case "no_code":
          errorMessage = "No authorization code received from Google."
          break
      }

      setAuthError(errorMessage)
      alert("Failed to authenticate with Google Calendar")
      // Limpiar la URL
      window.history.replaceState({}, document.title, window.location.pathname)
    } else if (accessToken && refreshToken) {
      const newTokens = {
        access_token: accessToken,
        refresh_token: refreshToken,
        expiry_date: expiresIn ? Number.parseInt(expiresIn) : undefined,
      }

      console.log("✅ Tokens received successfully:", {
        access_token: "Present",
        refresh_token: "Present",
        expiry_date: newTokens.expiry_date,
      })

      updateTokens(newTokens)
      setIsAuthenticated(true)
      setAuthError(null)

      // 🔥 AQUÍ SE GUARDAN LOS TOKENS EN LOCALSTORAGE
      localStorage.setItem("googleTokens", JSON.stringify(newTokens))

      // Limpiar la URL
      window.history.replaceState({}, document.title, window.location.pathname)

      alert("Successfully authenticated with Google Calendar")

      fetchEvents(newTokens)
    }
  }, [])

  const handleGoogleAuth = async () => {
    try {
      setLoading(true)
      setAuthError(null)
      const response = await fetch("http://localhost:4000/api/auth/google")
      const data = await response.json()

      // Redirigir al usuario a la URL de autorización de Google
      window.location.href = data.authUrl
    } catch (error) {
      console.error("Error initiating Google auth:", error)
      alert("Failed to initiate Google authentication")
    } finally {
      setLoading(false)
    }
  }

  const handleOAuthCallback = async (code) => {
    try {
      setLoading(true)
      const response = await fetch("http://localhost:4000/api/auth/google/callback", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ code }),
      })

      const data = await response.json()

      if (data.success) {
        setTokens(data.tokens)
        setIsAuthenticated(true)
        localStorage.setItem("googleTokens", JSON.stringify(data.tokens))

        // Limpiar la URL
        window.history.replaceState({}, document.title, window.location.pathname)

        alert("Successfully authenticated with Google Calendar")

        fetchEvents(data.tokens)
      }
    } catch (error) {
      console.error("Error handling OAuth callback:", error)
      alert("Failed to complete authentication")
    } finally {
      setLoading(false)
    }
  }

  const fetchEvents = async (authTokens) => {
    try {
      const response = await fetch(
        `http://localhost:4000/api/calendar/events?accessToken=${authTokens.access_token}&refreshToken=${authTokens.refresh_token}`,
      )
      const data = await response.json()

      if (data.success) {
        setEvents(data.events)

        // Si se devolvieron tokens actualizados, guardarlos
        if (data.updatedTokens) {
          console.log("🔄 Tokens were refreshed during fetch")
          updateTokens(data.updatedTokens)
        }
      } else if (data.requiresReauth) {
        handleAuthError("Authentication expired. Please re-authenticate.")
      }
    } catch (error) {
      console.error("init ------------- Error fetching events:", error)
    }
  }

  const createEvent = async () => {
    if (!tokens) return

    try {
      setLoading(true)
      const response = await fetch("http://localhost:4000/api/calendar/events", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          accessToken: tokens.access_token,
          refreshToken: tokens.refresh_token,
          event: eventForm,
        }),
      })

      const data = await response.json()

      if (data.success) {
        alert("Event created successfully in Google Calendar")

        // Limpiar el formulario
        setEventForm({
          title: "",
          description: "",
          startDateTime: "",
          endDateTime: "",
          timeZone: "America/New_York",
          attendees: [],
        })

        // Actualizar la lista de eventos
        fetchEvents(tokens)
      } else {
        throw new Error(data.error)
      }
    } catch (error) {
      console.error("Error creating event:", error)
      alert("Failed to create event")
    } finally {
      setLoading(false)
    }
  }

  const logout = () => {
    setTokens(null)
    setIsAuthenticated(false)
    setEvents([])
    localStorage.removeItem("googleTokens")
    alert("Successfully logged out from Google Calendar")
  }

  const formatDateTime = (dateTimeString) => {
    return new Date(dateTimeString).toLocaleString()
  }

  if (!isAuthenticated) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center p-4">
      {
        authError && <div>{authError}</div>
      }
        <Button onClick={handleGoogleAuth} disabled={loading} className="w-full">
          {loading ? "Connecting..." : "Connect Google Calendar"}
        </Button>

      </div>
    )
  }

  return (
    <div className="min-h-screen bg-gray-50 p-4">
      <div className="max-w-6xl mx-auto">
        <div className="flex justify-between items-center mb-8">
          <h1 className="text-3xl font-bold text-gray-900">Google Calendar Manager</h1>
          <Button onClick={logout}>
            Logout
          </Button>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {/* Formulario para crear eventos */}
          <div>


            <Input
              id="title"
              value={eventForm.title}
              onChange={(e) => setEventForm({ ...eventForm, title: e.target.value })}
              placeholder="Enter event title"
            />
          </div>
          <div>

            <TextArea
              id="description"
              value={eventForm.description}
              onChange={(e) => setEventForm({ ...eventForm, description: e.target.value })}
              placeholder="Enter event description"
            />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <input
                id="startDateTime"
                type="datetime-local"
                name="end"
                value={eventForm.startDateTime}
                onChange={(e) => setEventForm({ ...eventForm, startDateTime: e.target.value })}
                placeholder="datetime start"
              />
              {/* <Input
                    id="startDateTime"
                    type="datetime-local"
                    value={eventForm.startDateTime}
                    onChange={(e) => setEventForm({ ...eventForm, startDateTime: e.target.value })}
                  /> */}
            </div>

            <div>
              <input
                id="endDateTime"
                type="datetime-local"
                name="end"
                value={eventForm.endDateTime}
                onChange={(e) => setEventForm({ ...eventForm, endDateTime: e.target.value })}
                placeholder="datetime end"
              />
              {/* <Input
                    id="endDateTime"
                    type="dat"
                    value={eventForm.endDateTime}
                    onChange={(e) => setEventForm({ ...eventForm, endDateTime: e.target.value })}
                    placeholder="Datetime"
                  /> */}
            </div>
          </div>

          <Button
            onClick={createEvent}
            disabled={loading || !eventForm.title || !eventForm.startDateTime || !eventForm.endDateTime}
            className="w-full"
          >
            {loading ? "Creating..." : "Create Event"}
          </Button>


          {/* Lista de eventos */}
          {/* <Card>
            
            <CardContent>
              {events.length === 0 ? (
                <p className="text-gray-500 text-center py-8">No upcoming events found</p>
              ) : (
                <div className="space-y-4">
                  {events.map((event, index) => (
                    <div key={event.id || index} className="border rounded-lg p-4">
                      <h3 className="font-semibold text-lg">{event.summary}</h3>
                      {event.description && <p className="text-gray-600 mt-1">{event.description}</p>}
                      <div className="flex items-center gap-4 mt-2 text-sm text-gray-500">
                        <div className="flex items-center gap-1">

                          {event.start?.dateTime ? formatDateTime(event.start.dateTime) : event.start?.date}
                        </div>
                        {event.attendees && event.attendees.length > 0 && (
                          <div className="flex items-center gap-1">

                            {event.attendees.length} attendees
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </CardContent>
          </Card> */}
        </div>
      </div>
    </div>
  )
}
